// customerHotelReducer.js
import {
    FETCH_CUSTOMER_HOTEL_REQUEST,
    FETCH_CUSTOMER_HOTEL_SUCCESS,
    FETCH_CUSTOMER_HOTEL_FAILURE,
    ADD_CUSTOMER_HOTEL_REQUEST,
    ADD_CUSTOMER_HOTEL_SUCCESS,
    ADD_CUSTOMER_HOTEL_FAILURE,
    UPDATE_CUSTOMER_HOTEL_REQUEST,
    UPDATE_CUSTOMER_HOTEL_SUCCESS,
    UPDATE_CUSTOMER_HOTEL_FAILURE,
    DELETE_CUSTOMER_HOTEL_REQUEST,
    DELETE_CUSTOMER_HOTEL_SUCCESS,
    DELETE_CUSTOMER_HOTEL_FAILURE,
  } from "../action/customerHotelActions";
  
  const initialState = {
    customerHotels: [],
    loading: false,
    error: null,
  };
  
  const customerHotelReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CUSTOMER_HOTEL_REQUEST:
        return { ...state, loading: true };
      case FETCH_CUSTOMER_HOTEL_SUCCESS:
        return { ...state, loading: false, customerHotels: action.payload };
      case FETCH_CUSTOMER_HOTEL_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case ADD_CUSTOMER_HOTEL_REQUEST:
        return { ...state, loading: true };
      case ADD_CUSTOMER_HOTEL_SUCCESS:
        return {
          ...state,
          loading: false,
          customerHotels: [...state.customerHotels, action.payload],
        };
      case ADD_CUSTOMER_HOTEL_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case UPDATE_CUSTOMER_HOTEL_REQUEST:
        return { ...state, loading: true };
      case UPDATE_CUSTOMER_HOTEL_SUCCESS:
        return {
          ...state,
          loading: false,
          customerHotels: state.customerHotels.map((hotel) =>
            hotel.id === action.payload.id ? action.payload : hotel
          ),
        };
      case UPDATE_CUSTOMER_HOTEL_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case DELETE_CUSTOMER_HOTEL_REQUEST:
        return { ...state, loading: true };
      case DELETE_CUSTOMER_HOTEL_SUCCESS:
        return {
          ...state,
          loading: false,
          customerHotels: state.customerHotels.filter(
            (hotel) => hotel.id !== action.payload
          ),
        };
      case DELETE_CUSTOMER_HOTEL_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default customerHotelReducer;
  